import { useState, useEffect } from 'react';

/**
 * Hook to determine if device is mobile based on window width
 * @param breakpoint - breakpoint width (defaults to 768px)
 * @returns boolean - true if device is mobile
 */
export const useIsMobile = (breakpoint = 768): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(window.innerWidth <= breakpoint);

  useEffect(() => {
    function handleWindowSizeChange() {
      setIsMobile(window.innerWidth <= breakpoint);
    }

    handleWindowSizeChange();
    window.addEventListener('resize', handleWindowSizeChange);

    return () => {
      window.removeEventListener('resize', handleWindowSizeChange);
    };
  }, [breakpoint]);

  return isMobile;
};
